module.exports = __webpack_public_path__ + "media/errorDark.815e2ee3.svg";